/** @format */
//import { useClipboard } from '@vueuse/core';
import { Storage, param2Obj, uuid, isMobile, copyText } from '@power/utils';
import {
	request,
	requestRoot,
	download,
	downloadByUrl,
	postMessageUni,
	postMessageWindow,
	getFileUrlById,
} from '@/utils';
// import * as utils from '@/utils';
// console.log('utils', utils);
/**
 *
 * 更新 window.pData.env 。
 */
export async function initPDataEnv(env) {
	window.pData.env = {
		...window.pData?.env,
		...env,
	};
}

/**
 *
 * 初始化runtime-vue3相关方法到pData。建议直接通过PowerRuntime来使用相关方法。
 */
export function initPData() {
	// 存放全局数据
	if (!window.pData) {
		window.pData = {};
	}
	if (!window.pData.globalStore) {
		window.pData.globalStore = {};
	}
	const utils = {
		request,
		requestRoot,
		Storage,
		param2Obj,
		uuid,
		download,
		downloadByUrl,
		postMessageUni,
		postMessageWindow,
		getFileUrlById,
		isMobile,
		copyText,
	};
	if (!window.pData.utils) {
		window.pData.utils = utils;
	} else {
		window.pData.utils = Object.assign({}, window.pData.utils, utils);
	}

	//console.log('window.pData', window.pData);
}
